import { render, staticRenderFns } from "./tweet.vue?vue&type=template&id=2861b0bc&scoped=true&"
import script from "./tweet.vue?vue&type=script&lang=js&"
export * from "./tweet.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/reply.css?vue&type=style&index=0&id=2861b0bc&lang=css&scoped=true&"
import style1 from "./tweet.vue?vue&type=style&index=1&id=2861b0bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2861b0bc",
  null
  
)

export default component.exports